var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Button, ButtonGroup } from "@nexthink/apollo-components";
import { StyledTooltip } from "./ActionTooltip.style";
export const ActionTooltip = (_a) => {
    var { actions, position = "topLeft", offset } = _a, rest = __rest(_a, ["actions", "position", "offset"]);
    const renderButtons = () => {
        return actions.map((action, idx) => (React.createElement(Button, { key: idx, size: "small", "aria-label": action.name, onClick: action.onClick }, action.name)));
    };
    return (React.createElement(StyledTooltip, Object.assign({ position: position, offset: offset }, rest),
        React.createElement(ButtonGroup, null, renderButtons())));
};
export default ActionTooltip;
//# sourceMappingURL=ActionTooltip.js.map